import { useMediaQuery } from '@mui/material';
import Tab from '@mui/material/Tab';
import { default as MaterialTabs } from '@mui/material/Tabs';
import useActiveTabSelection from 'Hooks/useActiveTabSelection';
import { ReactNode } from 'react';
import { useHistory } from 'react-router-dom';
import mediaQueries from 'Theme/constants/mediaQueries';
import useTranslate from '../../../Hooks/useTranslate';
import { TProfileManagerMessagesKeys } from '../../../Languages/TProfileManagerMessages';

export type TTabView = {
  title: TProfileManagerMessagesKeys;
  component: ReactNode;
  icon?: ReactNode;
  path?: string;
  link?: string;
  testid?: string;
};
interface Props {
  views: TTabView[];
}

const Tabs = ({ views }: Props) => {
  const history = useHistory();
  const ts = useTranslate();

  const indexTabSelection = useActiveTabSelection({ tabs: views });

  const isMobileP = useMediaQuery(mediaQueries.mobilePortrait);

  const handleClick = (link?: string) => {
    if (link) history.replace(link);
  };

  return (
    <MaterialTabs
      value={indexTabSelection}
      indicatorColor="primary"
      textColor="primary"
      variant={isMobileP ? "scrollable" : "standard"}
      scrollButtons={isMobileP}
      allowScrollButtonsMobile={isMobileP}
    >
      {views.map(v => {
        return (
          <Tab
            key={v.title}
            label={(isMobileP && v.icon) ? v.icon : ts(v.title)}
            onClick={() => handleClick(v.link)}
            aria-label={v.title}
            data-testid={v.testid}
          />
        );
      })}
    </MaterialTabs>
  );
};

export default Tabs;
